import { render, staticRenderFns } from "./profitLossReports.vue?vue&type=template&id=34fbc5a2&scoped=true"
import script from "./profitLossReports.vue?vue&type=script&lang=js"
export * from "./profitLossReports.vue?vue&type=script&lang=js"
import style0 from "./profitLossReports.vue?vue&type=style&index=0&id=34fbc5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fbc5a2",
  null
  
)

export default component.exports